import { TableRow, TableCell } from "@mui/material";

// SPEED LIMIT
export default function SpeedLimit({ roadType, maxSpeedInMPH }: SpeedLimitProps) {
    return (
        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
            <TableCell component="th" scope="row" sx={{ fontSize: 17 }}>{roadType}</TableCell>
            <TableCell align="right" sx={{ fontSize: 17 }}>{maxSpeedInMPH} MPH</TableCell>
        </TableRow>
    )
}
